import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=ef5fca4e&scoped=true&"
import script from "./FileDropzone.vue?vue&type=script&lang=js&"
export * from "./FileDropzone.vue?vue&type=script&lang=js&"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&id=ef5fca4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5fca4e",
  null
  
)

/* custom blocks */
import block0 from "./FileDropzone.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports